(function () {
  "use strict";

  // Traduction simple basée sur <html lang="">
  function t(fr, en, nl) {
    const lang = (document.documentElement.lang || "fr").toLowerCase();
    if (lang.startsWith("nl")) return nl;
    if (lang.startsWith("en")) return en;
    return fr;
  }

  // Util : élément réellement visible (pas display:none, etc.)
  function isVisible(el) {
    if (!el) return false;
    const s = window.getComputedStyle(el);
    if (!s) return false;
    if (s.display === "none" || s.visibility === "hidden" || s.opacity === "0") return false;
    // offsetParent null peut être faux-positif sur certains layouts, donc on reste soft
    return true;
  }

  // Évite double wrap
  function alreadyWrapped(vatBlock) {
    return !!(vatBlock && vatBlock.closest && vatBlock.closest(".vat-accordion"));
  }

  function wrapVatBlock() {
    // ✅ Ciblage exact (vu sur ta capture)
    const vatBlock = document.querySelector("#oo-tax-exemption");
    if (!vatBlock) return;
    if (alreadyWrapped(vatBlock)) return;

    // Optionnel : remplacer le titre interne trop “bloquant”
    const innerTitle = vatBlock.querySelector("h3");
    if (innerTitle && /réservé aux professionnels|reserved for professionals|voor professionals/i.test(innerTitle.textContent || "")) {
      innerTitle.textContent = t(
        "Facturation entreprise (optionnel)",
        "Business invoicing (optional)",
        "Facturatie voor bedrijven (optioneel)"
      );
    }

    // Construire l'accordéon
    const details = document.createElement("details");
    details.className = "vat-accordion";
    details.open = false;

    const summary = document.createElement("summary");
    summary.className = "vat-accordion__summary";
    summary.textContent = t(
      "Vous êtes une entreprise ? Ajouter un numéro de TVA (optionnel)",
      "Buying as a business? Add a VAT number (optional)",
      "Koopt u als bedrijf? Voeg een btw-nummer toe (optioneel)"
    );

    const note = document.createElement("div");
    note.className = "vat-accordion__note";
    note.textContent = t(
      "Particuliers : ne remplissez rien, vous pouvez continuer normalement.",
      "Private customers: you can continue without filling anything in.",
      "Particulieren: u kunt gewoon verdergaan zonder iets in te vullen."
    );

    const content = document.createElement("div");
    content.className = "vat-accordion__content";

    // Déplacer le bloc TVA dans l'accordéon (uniquement ce bloc)
    const parent = vatBlock.parentNode;
    const placeholder = document.createElement("div");
    parent.insertBefore(placeholder, vatBlock);

    content.appendChild(vatBlock);

    details.appendChild(summary);
    details.appendChild(note);
    details.appendChild(content);

    parent.replaceChild(details, placeholder);

    // --- Ouverture intelligente ---
    // Fermer par défaut.
    // Ouvrir seulement si :
    // 1) l'utilisateur a déjà rempli email/TVA
    // 2) ou un message succès/erreur est réellement VISIBLE
    try {
      const emailInput =
        details.querySelector('input[type="email"]') ||
        details.querySelector('input[name*="email" i]');

      const vatInput =
        details.querySelector('input[name*="vat" i], input[name*="tva" i], input[name*="btw" i]') ||
        details.querySelector('input[placeholder*="TVA" i], input[placeholder*="VAT" i], input[placeholder*="BTW" i]');

      const hasValue =
        (emailInput && (emailInput.value || "").trim().length > 0) ||
        (vatInput && (vatInput.value || "").trim().length > 0);

      // OO VAT semble utiliser des divs cachées/affichées : #oo-tax-success / #oo-tax-error
      const successEl = details.querySelector("#oo-tax-success") || details.querySelector(".oo-tax-success");
      const errorEl = details.querySelector("#oo-tax-error") || details.querySelector(".oo-tax-error");

      const statusVisible = isVisible(successEl) || isVisible(errorEl);

      details.open = hasValue || statusVisible;
    } catch (e) {
      details.open = false;
    }

    // Si l'utilisateur commence à taper, on ouvre automatiquement (agréable UX)
    try {
      const watched = details.querySelectorAll('input[type="email"], input[name*="email" i], input[name*="vat" i], input[name*="tva" i], input[name*="btw" i]');
      watched.forEach((inp) => {
        inp.addEventListener("focus", () => (details.open = true), { passive: true });
        inp.addEventListener("input", () => {
          const v = (inp.value || "").trim();
          if (v.length > 0) details.open = true;
        }, { passive: true });
      });
    } catch (e) {}
  }

  // Init au chargement
  document.addEventListener("DOMContentLoaded", wrapVatBlock);

  // Re-init si le panier est re-rendu (ajax / apps / drawer)
  const mo = new MutationObserver(() => wrapVatBlock());
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
